'use strict';

angular.module('internal.inspections')
    .directive('internalInspectionNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'inspections/components/inspection-navigation/inspection-navigation.html',
            replace: true,
            controller: 'InternalNavigation'
        };
    }])
;